import store from '@/store';
import { isDev } from '@utils/flag';
import { Toast } from 'vant';
import bridge from './bridge';

const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};

const $ = window.Zepto;
const tenantId = '';

const BASE_URL = isDev()
  ? process.env.VUE_APP_ROUTER
  : `${window.location.origin}/api`;

function check(obj) {
  const localAccount = JSON.parse(localStorage.getItem('account')) || {}

  delete obj['name'];
  delete obj['plazaName'];

  for (let i in obj) {
    obj[i] = localAccount[i] || obj[i];

    if (!obj[i]) {
      delete obj[i];
    }
    
    if (obj[i] && /[\u4e00-\u9fa5]+/.test(obj[i])) {
      obj[i] = encodeURIComponent(obj[i]);
    }
  }
  return obj;
}

function axios(methods, url, data, headers, config) {
  headers = check(
    Object.assign({ tenantId }, Object.assign(headers, store.state.account))
  );

  return new Promise((rs, rj) => {
    $.ajax({
      type: methods,
      url: BASE_URL + url,
      headers,
      data,
      success(res) {
        // if (res.status == 200) {
        //   rs(res);
        // } else {
        //   rs(res);
        // }
        rs(res);
      },
      error(err) {
        // if (err.state == '403') {
        //   Toast.fail('登录过期');
        //   setTimeout(() => {
        //     if (isWechat()) {
        //       window.location.href = `${window.location.origin}${window.location.pathname}#/dq/login`;
        //     } else {
        //       let len = window.history.length;
        //       window.history.back(-len);
        //       bridge.goBack();
        //     }
        //   }, 200);
        // }else{
        //   Toast({
        //     message:'请求错误',
        //     duration:4000
        //   })
        // }
        console.log(err);
        Toast({
          message:'网络请求失败',
          duration:4000
        })
        rj(err);
      },
      ...config,
    });
  });
}

module.exports = {
  get(url, data, headers = {}, config) {
    return axios('GET', url, data, headers, config);
  },
  post(url, data, headers = {}, config) {
    return axios('POST', url, data, headers, config);
  },
  put(url, data, headers = {}, config) {
    return axios('PUT', url, data, headers, config);
  },
  // get(url, data, headers = {}, config) {
  //   headers = check(
  //     Object.assign({ tenantId }, Object.assign(headers, store.state.account))
  //   );
  //   return new Promise((rs, rj) => {
  //     $.ajax({
  //       type: 'GET',
  //       url: BASE_URL + url,
  //       headers,
  //       data,
  //       success(res) {
  //         rs(res);
  //       },
  //       error(err) {
  //         if(err.state == '403'){
  //           Toast.fail('登录过期');
  //           setTimeout(()=>{
  //             if (isWechat()) {
  //               window.location.href = `${window.location.origin}${window.location.pathname}/#/dq/login`
  //             } else {
  //               let len = window.history.length
  //               window.history.back(-len)
  //               bridge.goBack()
  //             }
  //           },200)
  //         }
  //         rj(err);
  //       },
  //       ...config,
  //     });
  //   });
  // },

  // post(url, data, headers = {}, config) {
  //   headers = check(
  //     Object.assign({ tenantId }, Object.assign(headers, store.state.account))
  //   );
  //   return new Promise((rs, rj) => {
  //     $.ajax({
  //       type: 'POST',
  //       url: BASE_URL + url,
  //       headers,
  //       data,
  //       success(res) {
  //         rs(res);
  //       },
  //       error(err) {
  //         if(err.state == '403'){
  //           Toast.fail('登录过期');
  //           setTimeout(()=>{
  //             if (isWechat()) {
  //               window.location.href = `${window.location.origin}${window.location.pathname}/#/dq/login`
  //             } else {
  //               let len = window.history.length
  //               window.history.back(-len)
  //               bridge.goBack()
  //             }
  //           },200)
  //         }
  //         rj(err);
  //       },
  //       ...config,
  //     });
  //   });
  // },
  // put(url, data, headers = {}, config) {
  //   headers = check(
  //     Object.assign({ tenantId }, Object.assign(headers, store.state.account))
  //   );
  //   return new Promise((rs, rj) => {
  //     $.ajax({
  //       type: 'PUT',
  //       url: BASE_URL + url,
  //       headers,
  //       data,
  //       success(res) {
  //         rs(res);
  //       },
  //       error(err) {
  //         rj(err);
  //       },
  //       ...config,
  //     });
  //   });
  // },
};
